<template>
  <div class="listRadioItem" @mouseover="mouseover" @mouseout="mouseout" :style="bgc">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "ListRadioItem",
    data(){
      return{
        isMouseover:false
      }
    },
    methods: {
      mouseover(){
        this.isMouseover = true
      },
      mouseout(){
        this.isMouseover = false
      }
    },
    computed: {
      bgc(){
        return this.isMouseover ? {"background-color": "#f8f9fa"} :{}
      }
    }
  }
</script>

<style scoped>
  .listRadioItem img{
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  .listRadioItem{
    color: #4b4b4b;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #c0c1c2;
    position: relative;
    z-index: 11;
  }
</style>
